export default __webpack_public_path__ + "static/media/popular-active.b7422446.svg";